import { RootState } from "../reducers";

export const getServiceDetails = (state: RootState) => state.serviceDetails;